module.exports = "/_next/static/files/573eb7487b511fecd6f1afe1ffd3f69c.png";